module.exports = __webpack_public_path__ + "static/media/logo-white-words.d15db709.svg";